import { Component, Input } from '@angular/core';

@Component({
    selector: 'dk-label',
    templateUrl: './dk-label.component.html',
    styleUrl: './dk-label.component.scss',
    standalone: false
})
export class DkLabelComponent {
  @Input() label: string;
  @Input() labelDescription: string;
  @Input() isRequired: boolean;
  @Input() disabled: boolean;
}
